import apiClient from './api';

/**
 * Service API pour la carte du statut hivernal des postes (SFD "Carte du
 * statut hivernal des postes"). Un seul endpoint renvoie tout ce que la
 * page affiche, statut deja calcule cote serveur - le frontend ne croise
 * jamais les parkings et les interventions lui-meme (RG-C01).
 */

export type StatutCarte =
  | 'indisponible'
  | 'en_cours'
  | 'en_attente_deneignement'
  | 'demande'
  | 'effectue'
  | 'aucune';

export interface InterventionCarte {
  id: number;
  reference: string;
  statut: string;
  priorite: string | null;
  equipe: string | null;
  heurePlanifiee: string | null;
  posteOccupe: boolean | null;
  immatriculationAvion: string | null;
  configuration: string | null;
  jalonsValides: number | null;
  jalonsTotal: number | null;
}

export interface PosteCarte {
  id: number;
  code: string;
  aire: string;
  latitude: number;
  longitude: number;
  situation: 'contact' | 'large' | null;
  statutHiver: string;
  statutCarte: StatutCarte;
  sansSituation: boolean;
  intervention: InterventionCarte | null;
}

export interface CarteCompteurs {
  aucune: number;
  demande: number;
  en_attente_deneignement: number;
  en_cours: number;
  effectue: number;
  indisponible: number;
  sansSituation: number;
  sansCoordonnees: number;
}

export interface CarteResponse {
  aeroport: string;
  genereLe: string;
  compteurs: CarteCompteurs;
  postes: PosteCarte[];
}

export const cartePostesService = {
  async getCarte(aeroport: 'ORY' | 'CDG'): Promise<CarteResponse> {
    const response = await apiClient.get<CarteResponse>('/parkings/carte', {
      params: { aeroport },
    });
    return response.data;
  },
};

export default cartePostesService;
